import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import OCRadioGroup from '@/components/OCRadioGroup';


@Component({
})
export default class OCRadio extends Mixins(BASEComponentVue) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public disable!: boolean;

    @Prop({
        type: [String, Boolean],
        default: "",
    })
    public value!: string | boolean;

    public boxClick() {
        if (this.disable) return;
        let group: OCRadioGroup = <any>this.$parent;
        group.setValue(this.value);
    }

    public getGroupValue() {
        if (this.disable) return;
        let group: OCRadioGroup = <any>this.$parent;
        return group.getValue();
    }

}
